import Vue from 'vue';
import moment from 'moment';
import store from './../../store';
import organizationMemberBookingTransformer from './../../transformers/organizationMemberBooking';
import helpers from '../../utils/helpers';


const success = ({ data }, resolve) => {
  const organizationMemberBookings = organizationMemberBookingTransformer.fetchCollection(data);
  store.dispatch('fetchAllOrganizationMemberBookings', organizationMemberBookings);
  resolve(organizationMemberBookings);
};

const failed = () => {
};


export default (startDate = null, endDate = null) => (
  new Promise((resolve, reject) => {
    const date = {
      end_date: endDate || moment().format('YYYY-MM-DD'),
      start_date: startDate || moment().format('YYYY-MM-DD'),
    };
    Vue.$http.get(helpers.buildUrl('/organization_member_bookings', date))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationMemberBooking/all.js